import React from 'react';

import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { axisTypes, legendStyle, lineChartMargin, lineChartTypes } from '../../../../constants/Dashboard';

const customizeTick = (props, type) => {
  const { x, y, payload } = props;
  
  const dy = type === axisTypes.x ? 11 : 0;
  const textAnchor = type === axisTypes.x ? 'middle' : 'end';
  
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={dy} fill={'#6b7280'} textAnchor={textAnchor} className="text-xs font-normal leading-[18px] tracking-normal">
        {payload.value}
      </text>
    </g>
  );
};

const customizeTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="flex h-[33px] w-[46px] items-center justify-center bg-white shadow-[0px_4px_8px_0px_#0000000d]">
        <span
          className="text-sm font-medium leading-[17px] tracking-normal">{`${payload[payload.length - 1].value}${payload.length > 1 ? '%' : ''}`}</span>
      </div>
    );
  }
  
  return null;
};

const LinearChart = ({ type, data, className }) => {
  return (
    <ResponsiveContainer width={'100%'} height={259} className={className}>
      <LineChart width={470} height={263} data={data} margin={lineChartMargin} className="border border-[#e8ecee] rounded-[10px]">
        <CartesianGrid vertical={false}/>
        <XAxis dataKey="date" axisLine={false} tickLine={false} tick={props => customizeTick(props, axisTypes.x)}/>
        <YAxis domain={[0, 100]} axisLine={false} ticks={[20, 40, 60, 80, 100]} tickLine={false} tick={props => customizeTick(props, axisTypes.y)}/>
        <Legend iconType="plainline" wrapperStyle={legendStyle}/>
        <Tooltip content={customizeTooltip}/>
        {type === lineChartTypes.single ? (
          <Line
            name="Net Promoter Scores"
            type="bump"
            dot={false}
            dataKey="nps"
            activeDot={false}
            stroke="#F89635"
            strokeWidth={3}
            className="[filter:drop-shadow(0px_0px_5px_#f89635)]"
          />
        ) : (
          <>
            <Line
              name="Industry average"
              type="bump"
              dot={false}
              dataKey="ia"
              activeDot={false}
              stroke="#F89635"
              strokeWidth={3}
              strokeDasharray="5 3"
              className="[filter:drop-shadow(0px_0px_5px_#f89635)]"
            />
            <Line
              name="Your average"
              type="bump"
              dot={false}
              dataKey="ya"
              activeDot={{ r: 8 }}
              stroke="#20CA96"
              strokeWidth={3}
              className="[filter:drop-shadow(0px_0px_5px_#20ca96)]"
            />
          </>
        )}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LinearChart;
